module.exports = __webpack_public_path__ + "img/logo-w.9218d580.png";